<template>
  <div>
    <oil-form
        v-if='loading'
        :title='formTitle'
        :items='formItems'
        :keys='formKeys'
        :createForm='!id'
        :formCallback='formCallback'
    >
      <template v-slot:header='{id}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-if='id' class='mx-8' type='button' icon
                   @click="showMePdf('contract/appendix/print',formItems.Id || id)"
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Product='{ rules, input }'>
        <v-row>
          <oil-product
              @setTotal='setTotal'
              :contract='contract'
              :input='input'
              :item='formItems.Item'
          />
        </v-row>
      </template>
    </oil-form>

    <div class='mt-5' v-if='(itemsTTN || []).length > 0'>
      <h2 class='mt-10 mb-10'>ТТН</h2>

      <min-table v-if="loading"
                 :items="itemsTTN"
                 :headers="keysTTN"
                 @clickUpdate="showWaybill"
                 @clickPdf="showWaybillPdf"
                 @clickDelete="deleteWaybill"
      >
        <template v-slot:Status="{value,object}">
          <v-chip v-if='object.IsReturned' disabled color='danger'>
            возврат
          </v-chip>
          <v-chip v-else :color='status(value).color'>
            {{ status(value).value }}
          </v-chip>
        </template>

        <template v-slot:ShipmentDate="{value}">
          {{ value | date }}
          <br>
          <small class='grey--text'>
            {{ value | time }}
          </small>
        </template>

      </min-table>


    </div>

  </div>
</template>

<script>

import {form} from '../setting/additional_contract_create.json'
import {contractsService} from '@/services/ContractsService.js'
import {additionalContractService} from '@/services/AdditionalContractService.js'
import {ProductCalc} from '@/utils/functions/Product'
import {table} from './tableTTN.json'
import {num2str} from "~/utils/functions/MoneyFromString";
import {waybillService} from "~/services/WayBillService";
import { coreApi } from '~/services/core'

export default {
  props: {
    id: String,
    contractId: String
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    OilTable: () => import('@/components/helper/oil.table'),
    Info: () => import('@/components/helper/productInfo/info'),
    OilProduct: () => import('./oilProduct'),
    MinTable: () => import('@/components/helper/table/MinTable')
  },
  data: () => ({
    contract: null,
    keysTTN: table.keys,
    itemsTTN: null,
    formKeys: form.keys,
    loading: false,
    statusLocal: {
      active: {value: 'Активный', color: 'success'},
      notsigned: {value: 'Неподписанный', color: 'lime'},
      special: {value: 'Особый', color: 'warning'},
      inactive: {value: 'Неактивный', color: 'red'},
      return: {value: 'возврат', color: ''}
    },
    formTitle: 'СОЗДАТЬ ДОПОЛНИТЕЛЬНОЕ ПРИЛОЖЕНИЕ',
    formItems: {
      Buyer: {},
      Seller: {},
      Item: {
        ProductId: '',
        AmountInTonne: '',
        AmountInLitre: '',
        GrossPricePerTonne: '',
        GrossPricePerLitre: '',
        NetPricePerTonne: 0,
        PricePerTonneNoVAT: '',
        tmpExcise: '',
        TotalPriceInText: '',
        ShowAmountInLitre: false,
        VATPerTonne: '',
        VATRate: 0,
        Density: '',
        Excise: '',
        Name: ''
      },
      DeliveryType: '',
      TotalExcise: '',
      VAT: '',
      NetTotal: '',
      TotalNoVat: '',
      Total: '',
      Number: '',
      ParentContractId: '',
      ParentContractNumber: '',
      ParentContractSignedDate: '',
      SecondTerm: 'Стоимость указана на условиях База Поставщика. Вывоз транспортными средствами Покупателя',
      SignedDate: '',
      Status: '',
      ItemDescription: '',
      TotalPriceInText: ''
    }
  }),
  async created() {
    if (this.id) {
      this.formTitle = 'ИНФО О ДОП. ПРИЛОЖЕНИЙ'
      const appendix = await additionalContractService.getAppById({
        id: this.id
      })

      const ID = this.id
      const ttn = await coreApi.get(`waybill/appendix/${ID}`)

      const contract = await contractsService.getById(
          appendix.data?.ParentContractId
      )
      this.itemsTTN = ttn.data?.map(w => {
        return {
          Number: w.Number,
          ShipmentDate: w.ShipmentDate,
          Status: w.Status,
          PDFID: w.Id,
          Id: w.Id
        }
      })
      this.formItems = {...this.formItems, ...appendix.data}
      this.formItems.Contract = contract.data
      this.contract = contract.data
      const product = {...appendix.data?.Item}
      const HasPrivelege = this.contract.Buyer.HasPrivelege
      product.tmpExcise = HasPrivelege ? 0 : product.Excise
      this.formItems.Item = product
      this.formItems.Item.total = this.formItems.Total
    } else {
      this.formItems.Item.VATRate = ''
    }
    if (this.contractId) {
      const contract = await contractsService.getById(this.contractId)
      this.formItems.Contract = contract.data
      this.formItems.Item.VATRate = ''
      this.contract = contract.data
    }

    this.loading = true
  },
  computed: {
    waybills() {
      const waybills = this.formItems.WaybillModels || []

    },
    storeType() {
      if (this.id) {
        return additionalContractService.update
      }
      return additionalContractService.create
    }
  },
  methods: {
    status(value) {
      return this.statusLocal[value] || {
        value: value,
        color: ''
      }
    },
    showWaybill(id) {
      this.$router.push(`/waybill-update/${id}`)
    },
    showWaybillPdf(id) {
      this.showMePdf('waybill/print', id)
    },
    async deleteWaybill(id) {
      const response = await waybillService.delete(id)
      const isDelete = response.data
      if (isDelete) {
        const waybill = this.itemsTTN.find(({Id}) => Id === id)
        const index = this.itemsTTN.indexOf(waybill)
        this.itemsTTN.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `ТТН под номером ${waybill.Number} удачно удален`
        })
      }
    },
    colorStatus(val) {
      if (val === 'active') {
        return 'success'
      } else if (val === 'inactive') {
        return 'red'
      } else if (val === 'special') {
        return 'warning'
      } else if (val === 'notsigned') {
        return 'lime'
      }
    },
    setTotal(total) {
      this.formItems.Total = total()
      this.formItems.TotalPriceInText = num2str(this.formItems.Total)
    },
    async handleRowClick(id) {
      await this.$router.push(`/waybill-update/${id}`)
    },
    async formCallback(data) {
      const item = this.formItems.Item
      item.VATPerTonne = ProductCalc.Nds(item)
      item.PricePerTonneNoVAT = ProductCalc.PriceClearNdsPrice(item)
      data.ParentContractId = this.contract.Id
      data.ParentContractSignedDate = this.contract.SignedDate
      data.Buyer = this.contract.Buyer
      data.TotalExcise = ProductCalc.TotalExcise(item)
      data.VAT = ProductCalc.Nds(item)
      data.TotalNoVat = ProductCalc.PriceClearNdsPrices(item)
      data.NetTotal = ProductCalc.PriceClearTons(item)
      data.TotalNproductsoVat = ProductCalc.PriceClearNdsPrices(item)
      data.TotalPriceInText = item.TotalPriceInText

      if (item.ShowAmountInLitre) {
        data.Total = parseFloat(item.AmountInLitre * item.GrossPricePerLitre)
            .toFixed(0)
      } else {
        data.Total = parseFloat(item.AmountInTonne * item.GrossPricePerTonne)
            .toFixed(0)
      }

      item.Excise = item.tmpExcise
      console.log('data', data.Item);
      const response = await this.storeType(data)
      if (!response.data) {
        return
      }
      await this.showMePdf('contract/appendix/print', response.data?.Id)
      await this.$router.back()
    }
  }
}
</script>
